<template lang="html">
  <div tabindex="100" @keydown.up.prevent="onArrowUpPress" @keydown.down.prevent="onArrowDownPress">
    <usuario-funcionario-filtros
    ref="filtros"
    @UsuarioFuncionarioFiltros__AplicaFiltros="aplicaFiltros">
    </usuario-funcionario-filtros>
    <v-card class="card-size">
      <v-card-title>
        <h2 class="headline mb-0" v-text="title">
        </h2>
      </v-card-title>

      <v-data-table :headers="headers" :items="registros" :options.sync="pagination" :item-class="onItemClass"
        :server-items-length="totalPage" :no-data-text="$t('label.tabela_sem_conteudo')" :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }">
        <template v-slot:item.acoes="{ item }">
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="podeEditar(item)" @click="edit(item)">
                <v-list-item-action>
                  <v-icon>edit</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.editar') }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="podeVisualizar(item)" @click="ver(item)">
                <v-list-item-action>
                  <v-icon>dehaze</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.visualizar') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="buscaDadosUltimaAlteracao(item)">
                <v-list-item-action>
                  <v-icon>app_registration</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.ultima_alteracao') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="buscaRelatorioLogUsuarioPorId(item)">
                <v-list-item-action>
                  <v-icon>get_app</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.exportar_log') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="limparWorkspaceFiltros(item.id)">
                <v-list-item-action>
                  <v-icon>filter_alt_off</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $tc('label.limpar_filtros', 1) }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.nome_sobrenome="{ item }">
          {{ item.nomeSobrenome }}
        </template>
        <template v-slot:item.nom_usuario="{ item }">
          {{ item.nomUsuario }}
        </template>
        <template v-slot:item.nom_perfil="{ item }">
          {{ item.nomPerfil }}
        </template>
        <template v-slot:item.nom_estrutura_usuario="{ item }" v-if="isUsuarioFuncionario">
          {{ item.nomEstruturaUsuario }}
        </template>
        <template v-slot:item.divisoes="{ item }" >
          {{ getNomesDivisoesSeparadosPorVirgula(item.divisoes) }}
        </template>
      </v-data-table>
    </v-card>
    <modal-dados-ultima-alteracao-usuario ref="modalDadosUltimaAlteracaoUsuario">
    </modal-dados-ultima-alteracao-usuario>
  </div>
</template>

<script type="text/javascript">
import {
  mapGetters,
} from 'vuex';
import { removeEmptyProperties } from '@/common/functions/helpers';
import exportacao from '@/common/functions/exportacao';
import { countRelatorioLogUsuario } from '@/common/resources/magalu-relatorios';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import {
  forceHideLoading,
  forceLoading,
} from '@/common/functions/loading';
import Status from '@/shared-components/Status';
import ModalDadosUltimaAlteracaoUsuario from '@/shared-components/ModalDadosUltimaAlteracaoUsuario';
import UsuarioFuncionarioFiltros from '@/spa/usuario/UsuarioFuncionarioFiltros';
import UsuarioAnexosDialog from './UsuarioAnexosDialog';

export default {
  components: {
    UsuarioAnexosDialog,
    ModalDadosUltimaAlteracaoUsuario,
    UsuarioFuncionarioFiltros,
    Status,
  },
  data() {
    return {
      workspaceFiltrosResources: this.$api.workspaceFiltros(this.$resource),
      usuarioResources: this.$api.usuario(this.$resource),
      perfilResource: this.$api.perfil(this.$resource),
      divisaoResources: this.$api.divisao(this.$resource),
      configSistemaResource: this.$api.configuracaoSistema(this.$resource),
      headers: [
        {
          text: this.$tc('label.acoes', 2), sortable: false, align: 'center', value: 'acoes',
        },
        { text: this.$t('label.nome'), sortable: true, value: 'nome' },
        { text: this.$t('label.email'), sortable: true, value: 'email' },
        { text: this.$t('label.login'), sortable: true, value: 'nom_usuario' },
        { text: this.$tc('label.perfil', 1), value: 'nom_perfil' },
      ],
      workspace: {},
      entidadeWorkspace: 'gestao_usuario_funcionario',
      pagination: {},
      totalPage: 0,
      esperar: false,
      registros: [],
      filtrosAplicados: {},
      bloquearExportacao: false,
    };
  },
  props: {
    title: String,
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar(true);
      },
      deep: true,
    },
    paginationSize(valor) {
      this.$emit('PAGINACAO_ALTERANDO_TAMANHO_PAGINA', valor);
    },
  },
  computed: {
    ...mapGetters('implantacao', [
      'implantacao',
      'chaveEmpresa',
    ]),
    ...generateComputed('Usr', [
      'canAccessCRUD',
      'canSearch',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    isContentAvailable() {
      return !!this.tableData && !!this.tableData.length;
    },
    usuarioFilteredList() {
      return this.tableData.map((linha) => {
        const row = { ...linha };
        row.representante = {};
        row.representante.dependencias = this.stringToArray(linha);
        row.superioresImediatosArray = this.parseStringSuperioresImediatos(linha);
        row.canaisArray = this.parseStringCanal(linha);

        return row;
      });
    },
    filteredList() {
      return [];
    },
    isUsuarioFuncionario() {
      return this.usuarioLogado.tipo === 'FUNCIONARIO';
    },
    cadastrarGestaoFuncionario() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CADASTRAR_GESTAO_DE_FUNCIONARIO').length;
    },
    consultarGestaoFuncionario() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CONSULTAR_GESTAO_DE_FUNCIONARIO').length;
    },
    permitirSomenteEdicaoUsuarioFuncionario() {
      if (!this.getAllRoles) {
        return false;
      }
      return this.getAllRoles
        .filter((el) => el.indexOf('USR_PERMISSAO_EDITAR_USR_FUNCIONARIO') !== -1).length > 0;
    },
    isAmbienteMagalu() {
      return this.chaveEmpresa === 'MAGALU';
    },
    isAmbienteEpoca() {
      return this.chaveEmpresa === 'EPOCA';
    },
    isAmbienteKabum() {
      return this.chaveEmpresa === 'KABUM';
    },
  },
  methods: {
    dispararFiltro() {
      this.pagination.page = 1;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.filtrar(false), 400);
    },
    buscar(trocaPagina) {
      if (!trocaPagina) {
        this.pagination.page = 1;
      }
      const params = {
        ...this.filtrosAplicados,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
        indTabelaFuncionario: true,
      };
      if (this.filtrosAplicados.nome) params.nome = this.filtrosAplicados.nome;
      if (this.filtrosAplicados.email) params.email = this.filtrosAplicados.email.trim();
      if (this.filtrosAplicados.login) params.login = this.filtrosAplicados.login.trim();
      if (this.filtrosAplicados.perfis?.length) params.perfis = this.filtrosAplicados.perfis.join(',').trim();
      if (this.filtrosAplicados.divisoes?.length) params.divisoes = this.filtrosAplicados.divisoes.join(',').trim();
      if (this.filtrosAplicados.ativos?.length) params.ativos = this.filtrosAplicados.ativos.join(',').trim();
      if (this.filtrosAplicados.indUsuariosAguardandoComplementoCadastro) {
        params.indUsuariosAguardandoComplementoCadastro = this.filtrosAplicados.indUsuariosAguardandoComplementoCadastro;
      }
      this.usuarioResources.listar(params)
        .then((response) => {
          this.registros = response.data.resposta;
          this.totalPage = response.data.quantidadeRegistrosPagina;
          this.$refs.filtros.toggleFiltros();
          this.pararEsperar();
        }, (err) => {
          this.pararEsperar();
          this.$error(this, err);
        });
    },
    filtrar(trocaPagina) {
      if (this.esperar) return;
      this.esperar = true;
      forceLoading();
      setTimeout(() => {
        this.buscar(trocaPagina);
      }, 1000);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
        forceHideLoading();
      }, 2E2);
    },
    aplicaFiltros(filtros = {}) {
      if (Object.keys(filtros).length > 0) {
        this.filtrosAplicados = filtros;
      } else {
        this.filtrosAplicados = {};
      }
      this.filtrar(false);
    },
    montaTexto(item) {
      if (!item) {
        return '';
      }
      const array = item.split('|');
      return (`${array[2]}`) || '';
    },
    edit(row) {
      this.$emit('USUARIOTABELA_EDIT', row);
    },
    ver(row) {
      this.$emit('USUARIOTABELA_VER', row);
    },
    getNomesDivisoesSeparadosPorVirgula(nomeObjeto) {
      if (!nomeObjeto) {
        return '';
      }
      return nomeObjeto.split(';;').join(', ');
    },
    stringToArray(linha) {
      const canaisVendaRepresentanteObj = !linha.canaisVendaRepresentante ? []
        : linha.canaisVendaRepresentante.split(',').map((cat) => {
          const canaisVendaRepresentanteStr = cat.split(':');
          return {
            id: parseInt(canaisVendaRepresentanteStr[0], 10),
            nomExtensao: canaisVendaRepresentanteStr[1],
            indAtivo: canaisVendaRepresentanteStr[2],
          };
        });

      return {
        canaisVenda: canaisVendaRepresentanteObj,
      };
    },
    abrirModalAnexos(usuario) {
      this.$refs.usuarioAnexosDialog.open(usuario);
    },
    podeEditar() {
      return this.canAccessCRUD && (this.cadastrarGestaoFuncionario || this.permitirSomenteEdicaoUsuarioFuncionario) && this.isUsuarioFuncionario;
    },
    podeVisualizar() {
      return this.consultarGestaoFuncionario && !(this.canAccessCRUD && this.cadastrarGestaoFuncionario)
       && !this.permitirSomenteEdicaoUsuarioFuncionario;
    },
    buscaRelatorioLogUsuarioPorId(usuario) {
      const params = {
        id_usuario_selecionado: usuario.idUsuario ? usuario.idUsuario : usuario.id,
        ind_usuario_funcionario: true,
      };
      let quantidadeRegistros = 0;

      countRelatorioLogUsuario(params, this.$resource)
        .then((response) => {
          quantidadeRegistros = response.data;
          if (quantidadeRegistros > this.limiteRegistrosExportacao) {
            this.$toast(this.$t('errors.registros.excede_limite_dados', { limite: this.limiteRegistrosExportacao }));
          } else if (quantidadeRegistros > 0) {
            this.requestExportacao(params, 'log_usuario_magalu', 'api');
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestExportacao(params, tipoRelatorio, modulo = 'api') {
      const filtroTratado = removeEmptyProperties(params);
      this.bloquearExportacao = true;

      exportacao.exportar(() => {
        this.bloquearExportacao = false;
      }, tipoRelatorio, this, filtroTratado, 5000, 0, modulo);
    },
    buscaDadosUltimaAlteracao(item) {
      const dados = {
        idUsuario: item.id,
      };
      setTimeout(() => this.$refs.modalDadosUltimaAlteracaoUsuario.open(dados), 2E2);
    },
    limparWorkspaceFiltros(idUsuario) {
      const entidade = this.entidadeWorkspace;
      const params = {
        entidade,
        idUsuario,
      };
      this.workspaceFiltrosResources
        .limpar(params, params)
        .then(() => {
          this.$toast(this.$t('message.filtros_removidos'));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    inserirHeaders() {
      this.headers.push({ text: this.$tc('label.usuario_ultima_alteracao', 1), value: 'usuarioAlteracao', sortable: false });
      this.headers.push({ text: this.$tc('label.divisao', 1), value: 'divisoes' });
    },
  },
  mounted() {
    forceLoading();
    this.inserirHeaders();
  },
};
</script>
